// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9k9C1","importantInfo":"styles_importantInfo__5K_2-"};